import { HIT_DATA_FACT_ID, COMMERCIAL_SUPPLIERS_FACT_ID, COMMERCIAL_SUPPLIERS_FACT_CHILD_ID } from '@Constants';

export const isFactHitData = ({ id }) => id === HIT_DATA_FACT_ID;
export const isFactCommercialSuppliers = ({ id }) => id === COMMERCIAL_SUPPLIERS_FACT_ID;
export const isChildCommercialSuppliers = ({ id }) => id === COMMERCIAL_SUPPLIERS_FACT_CHILD_ID;

export const isFactHitDataCommercialSuppliers = (fact) => {
  const { children } = fact;
  return isFactHitData(fact) && children.some(isChildCommercialSuppliers);
};

export const getFactCount = (fact, { suppUnq }) => {
  if (suppUnq && isFactHitDataCommercialSuppliers(fact)) {
    return suppUnq.hitCount;
  }

  if (suppUnq && isFactCommercialSuppliers(fact)) {
    return suppUnq.count;
  }

  return fact.count;
};

export const getChildHitCount = (child) => child.hit;

export const getChildCount = (child) => child.count;
